import { createRouter, createWebHashHistory } from 'vue-router';
import DashBoards from '../views/DashBoards.vue';
import UserLogin from '../views/UserLogin.vue';
import AdminAgencyRegister from '../views/AdminAgencyRegister.vue';
import AdminAgencyEdit from '../views/AdminAgencyEdit.vue';
import WildlifeDamageMap from '../views/WildlifeDamageMap.vue';
import WildlifeDamageList from '../views/WildlifeDamageList.vue';
import WildlifeDamageListDetail from '../views/WildlifeDamageListDetail.vue';
import WildlifeDamageListEdit from '../views/WildlifeDamageListEdit.vue';
import WildlifeCounterPlanList from '@/views/WildlifeCounterPlanList.vue';
import WildlifeCounterPlanListDetail from '@/views/WildlifeCounterPlanListDetail.vue';
import WildlifeCounterPlanListEdit from '../views/WildlifeCounterPlanListEdit.vue';
import UserRegister from '../views/UserRegister.vue';
import UserEdit from '../views/UserEdit.vue';
import UserInfo from '../views/UserInfo.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: UserLogin,
    meta: {
      title: 'MIELOUPE(WEB)ログイン'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: DashBoards,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
     }
  },
  {
    path: '/damageMap',
    name: 'WildlifeDamageMap',
    component: WildlifeDamageMap,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
    }
  },
  {
    path: '/agencyEdit',
    name: 'AdminAgencyEdit',
    component: AdminAgencyEdit,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
    }
  },
  {
    path: '/agencyRegister',
    name: 'AdminAgencyRegister',
    component: AdminAgencyRegister,
    meta: { requiresAuth: true,
            title: 'MIELOUPE'
    }
  },
  {
    path: '/damageList',
    name: 'WildlifeDamageList',
    component: WildlifeDamageList,
    meta: { requiresAuth: true,
             title: 'MIELOUPE'
     }
  }, 
  {
    path: '/damageDetail',
    name: 'WildlifeDamageListDetail',
    component: WildlifeDamageListDetail,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  },
  {
    path: '/damageEdit',
    name: 'WildlifeDamageListEdit',
    component: WildlifeDamageListEdit,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  },
  {
    path: '/counterPlanList',
    name: 'WildlifeCounterPlanList',
    component: WildlifeCounterPlanList,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  },  
  {
    path: '/counterPlanDetail',
    name: 'WildlifeCounterPlanListDetail',
    component: WildlifeCounterPlanListDetail,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  }, 
  {
    path: '/counterPlanEdit',
    name: 'WildlifeCounterPlanListEdit',
    component: WildlifeCounterPlanListEdit,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
    props: true
  },
  {
    path: '/user',
    name: 'UserInfo',
    component: UserInfo,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  },
  {
    path: '/userRegister',
    name: 'UserRegister',
    component: UserRegister,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  },
  {
    path: '/userEdit',
    name: 'UserEdit',
    component: UserEdit,
    meta: { requiresAuth: true,
      title: 'MIELOUPE'
    },
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// ルートガードを追加して認証チェック
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('jwtToken') !== null;

  // ページタイトルを設定
  router.afterEach((to, from) => {
    document.title = to.meta.title
  })

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login');
  } else {
    next();
  }
});

export default router;
